export const prefix = '[Edit / Learning Path]';
